import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarPerson } from '@factorialco/f0-react'
import { ContractHistoryContractVersionHistoryFragment } from 'generated/resources/graphql'
import moment from 'moment'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

interface Props {
  version: ContractHistoryContractVersionHistoryFragment
}

const CreatedBy = ({ version }: Props) => {
  return (
    <Box flexDirection="row" gap="s8" alignItems="center">
      <Box flexDirection="row" gap="s4" alignItems="center" width="s200">
        <Text.Normal size="200" color="grey800" weight="normal">
          {i18n.t('contract_versions.navigator.history.created_by')}
        </Text.Normal>
      </Box>
      <F0AvatarPerson
        firstName={version.createdByName?.split(' ')[0] || ''}
        lastName={version.createdByName?.split(' ')[1] || ''}
        size="xs"
        src={version.createdByAvatar ? buildUrl(version.createdByAvatar) : undefined}
      />
      <Text.Normal size="200" color="grey1000" weight="medium">
        {version.createdByName}
      </Text.Normal>
      <Text.Normal size="100" color="grey1000" weight="medium">
        •
      </Text.Normal>
      <Text.Normal size="200" color="grey1000" weight="medium">
        {moment(version.createdAt).format('DD/MM/YYYY')}
      </Text.Normal>
    </Box>
  )
}

export default CreatedBy
